export interface SubmitGuard {
  begin(): boolean;
  end(): void;
}

// Creates a single-flight guard. begin() returns false while a submit is
// already in flight (and otherwise marks in-flight and returns true). end()
// clears the in-flight flag. State lives in the closure so the guard can be
// shared by reference across a component's renders and callbacks.
export function createSubmitGuard(): SubmitGuard {
  let inFlight = false;

  return {
    begin() {
      if (inFlight) return false;
      inFlight = true;
      return true;
    },
    end() {
      inFlight = false;
    },
  };
}
